import { enqueueSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { CREATE_GOOGLE_AD_MANAGER_CONNECTION } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseCreateConnection } from './types'

export const useCreateConnection = (): UseCreateConnection => {
  const { workspaceId } = useWorkspaceParam()
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection.connectionStatus',
  })

  const { isPending, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: CREATE_GOOGLE_AD_MANAGER_CONNECTION,
    onCompleted: async ({ createGamConnectionOrder: { errors } }: Data): Promise<void> => {
      if (errors && errors.length > 0) {
        enqueueSnackbar(t('notification.error'), { variant: 'error' })
      }
    },
    queriesToInvalidate: ['getGoogleAdManagerConnection'],
  })

  const create = (): void => {
    mutateAsync({ input: { workspaceId } })
  }

  return {
    create,
    loading: isPending,
  }
}
